const RENTALS_PAYMENT_MODELS = {
  RENTALS_ROOT_PAYMENT_MODELS: 'RENTALS_ROOT_PAYMENT_MODELS',
};

export default RENTALS_PAYMENT_MODELS;
